// Multi-language translations for SF-Maler website
// Swiss German spelling (ss instead of ß)

export const translations = {
  de: {
    common: {
      phone: "079 607 01 48",
      email: "info@sf-maler.ch",
      address: "Wollbacherstrasse 35, 4058 Basel",
      company: "Malergeschäft Sammy Felber",
      tagline: "Maler · Tapezier · Fassaden",
      cta_offer: "Offerte anfordern",
      cta_call: "Jetzt anrufen",
      cta_contact: "Kontakt aufnehmen",
      cta_consult: "Kostenlose Beratung",
      cta_more: "Mehr erfahren",
      cta_send: "Nachricht senden",
      learn_more: "Mehr erfahren",
    },
    nav: {
      home: "Startseite",
      services: "Dienstleistungen",
      gallery: "Referenzen",
      team: "Team",
      about: "Über uns",
      about_overview: "Firma & Werte",
      contact: "Kontakt",
      all_services: "Alle Dienstleistungen anzeigen",
    },
    segment: {
      private: "Privatkunden",
      commercial: "Gewerbe & Liegenschaften",
      private_short: "Privat",
      commercial_short: "Gewerbe",
    },
    home: {
      hero_overline: "Malergeschäft Sammy Felber · Basel",
      hero_title: "Maler. Tapezierer. Fassadenprofis.",
      hero_subtitle: "Wir sind ein erfahrenes und professionelles Unternehmen, spezialisiert auf das Streichen und Tapezieren von Räumen sowie auf das Streichen von Fassaden. Ob Renovierung, Umbau oder Neubau – Ihr zuverlässiger Partner für Tapezier-, Maler- und Fassadenarbeiten.",
      hero_title_private: "Maler in Basel für Ihre Wohnung, Ihr Haus, Ihre Renovation.",
      hero_subtitle_private: "Der zuverlässige Malermeister für Privatkunden in Basel und Umgebung. Wohnung streichen, Tapezieren, Renovation nach Umzug – schnell, sauber, faire Fixpreise. Eidg. dipl. Maler mit Gewerbeversicherung. Kostenlose Vor-Ort-Beratung innerhalb 48 Stunden.",
      hero_title_commercial: "Ihr Partner für Fassaden, Liegenschaften & Grossobjekte.",
      hero_subtitle_commercial: "Malergeschäft für Verwaltungen, Architekturbüros, Bauträger und KMU in der Region Basel. Fassadensanierung, Wärmedämmung, Trockenbau und Objektlackierung in eigener Spritzwerkstatt. Rahmenverträge, GU-fähige Abwicklung, Termintreue garantiert.",
      hero_trust1: "Eidg. dipl. Maler",
      hero_trust2: "Seit 2018 in Basel",
      hero_trust3: "Eigene Spritzwerkstatt",
      services_overline: "Was wir können",
      services_title: "Unsere Dienstleistungen",
      services_subtitle: "Vom ersten Pinselstrich bis zur fertigen Fassade – wir liefern handwerkliche Qualität mit Schweizer Präzision.",
      why_overline: "Warum SF-Maler",
      why_title: "Qualität, Service & Erfahrung",
      why_subtitle: "Sechs Gründe, weshalb Privatkunden, Architekturbüros und KMU's auf uns vertrauen.",
      why_1_title: "Qualität & Service",
      why_1_text: "Saubere, langlebige Resultate – garantiert.",
      why_2_title: "Erfahrung",
      why_2_text: "Eidg. dipl. Maler mit jahrelanger Praxis.",
      why_3_title: "Zuverlässigkeit",
      why_3_text: "Termintreu, sauber, unkompliziert.",
      why_4_title: "Spachteltechnik-Spezialist",
      why_4_text: "Stucco Antico, Veneziano und mehr.",
      why_5_title: "Eigene Spritzwerkstatt",
      why_5_text: "Hochglanz, matt – Klein- und Grossobjekte.",
      why_6_title: "Denkmalpflege",
      why_6_text: "Erfahrung mit historischer Bausubstanz.",
      ba_overline: "Vorher · Nachher",
      ba_title: "Sehen Sie den Unterschied",
      ba_subtitle: "Echte Projekte. Echte Resultate. Bewegen Sie den Schieber.",
      gallery_overline: "Referenzen",
      gallery_title: "Ausgewählte Projekte",
      gallery_subtitle: "Ein Auszug aus unseren letzten Arbeiten in Basel und Umgebung.",
      gallery_cta: "Alle Referenzen ansehen",
      testimonials_overline: "Kundenstimmen",
      testimonials_title: "Was Kunden über uns sagen",
      cta_section_title: "Bereit für Ihr Projekt?",
      cta_section_text: "Vereinbaren Sie eine kostenlose, unverbindliche Beratung. Wir besichtigen Ihr Objekt und erstellen Ihnen ein faires Angebot.",
    },
    services: {
      overline: "Dienstleistungen",
      title: "Unser komplettes Angebot",
      subtitle: "Von der klassischen Malerarbeit bis zur Spezialtechnik – alles aus einer Hand.",
      detail_intro: "Leistungsumfang",
      detail_cta_title: "Jetzt unverbindliches Angebot anfordern",
      detail_cta_text: "Wir beraten Sie kostenlos und erstellen Ihnen ein massgeschneidertes Angebot.",
      items: {
        malerarbeiten: {
          title: "Malerarbeiten",
          short: "Innen- und Aussenmalerei in höchster Qualität – mit Jupol, Oelfarben, Lacken und mehr.",
          features: ["Malerei des ganzen Hauses", "Doppeltes Bleichen der Wohnung", "Glätten und Bleichen der Decke", "Wandstreichen mit Jupol", "Erneuerung alter Fassaden", "Toplasur Dachvorsprung", "Bemalen von MDF-Türen", "Lackierermeister", "Oelfarben & Lacke", "Arbeiten am Denkmalschutz", "Brandschutzanstriche", "Betonschutzanstriche"],
        },
        tapezier: {
          title: "Tapezierarbeiten",
          short: "Vom Entfernen alter Tapeten bis zur exklusiven Spachteltechnik wie Stucco Veneziano.",
          features: ["Beseitigung von Tapeten", "Pre-Wandtapete", "Geklebte Tapeten", "Tapetenproben & Fototapeten", "Dekorationen (Schrift, Ornament)", "Spachtel- und Schwammtechnik", "Schablonen/Folien", "Spachteltechnik (Stucco Antico)", "Stucco Veneziano", "Schimmelbehandlung", "Vergoldungen"],
        },
        fassaden: {
          title: "Fassadenarbeiten",
          short: "Komplette Fassadensanierung, Wärmedämmung und Schutz vor Wetter und Graffiti.",
          features: ["Fassade Neubau", "Fassadensanierung", "Dachgesims Knauf", "Sockel aus Styrodur", "Isolierung Balkon", "Silikon Oberschicht", "Fassade Styrodur 15cm", "Renovierung alter Fassaden", "Fassadenverkleidung", "Fassadenreinigung", "Wärmedämmung aussen & innen", "Graffitischutz / -entfernung", "Denkmalpflege"],
        },
        daemmung: {
          title: "Dämmung & Isolierung",
          short: "Wärmetechnische Verbesserung Ihres Gebäudes – innen wie aussen.",
          features: ["Dachboden dämmen", "Dächer isolieren", "Dämmung mit Mineralwolle", "Gipskartonplatten Dachgeschoss", "Einblasdämmung Zellulose", "Wärmedämmung aussen & innen"],
        },
        holzmalerei: {
          title: "Holzmalerei",
          short: "Holzoberflächen schleifen, spachteln, lasieren oder lackieren.",
          features: ["Bemalung Holzoberflächen", "Renovierung Holzzaun", "Schleifen von altem Holz", "Spachteln Holzfenster", "Holzdachvorsprung", "Holzlasur", "Fensterläden", "Jalousiearbeiten"],
        },
        stuck: {
          title: "Stuckleisten",
          short: "Stuckatur und Zierprofile aus Styropor – innen wie an der Fassade.",
          features: ["Stuckatur aus Styropor", "Fassaden Stuckatur", "Zierprofile aus Styropor"],
        },
        trockenbau: {
          title: "Trockenbau",
          short: "Gipsdecken, Trennwände, Verkleidungen und Dachgeschossausbau.",
          features: ["Trockenaufstellung", "Spachteln", "Gipsdecke", "Trennwände mit Alu-Gitter", "Hüllenwand", "Dachgeschossausbau", "Verkleidung Dachvorsprung"],
        },
        putz: {
          title: "Putzarbeiten",
          short: "Klassischer Innen- und Aussenputz – maschinell oder von Hand.",
          features: ["Aussenputz (Maschine)", "Strukturmaschinenputz", "Maschinenputz Kalksand", "Maschinenputz Wände/Decken", "Klassischer Innenputz", "Klassischer Gips Neubau", "Gips an der Wand", "Handspritzen", "Mauer verputzen"],
        },
        spritz: {
          title: "Spritzarbeiten",
          short: "Hauseigene Spritzwerkstatt für anspruchsvolle Arbeiten – hochglanz und matt.",
          features: ["Allgemeine Spritzarbeiten", "Hauseigene Spritzwerkstatt", "Hochglanz und matt", "Jalousie bis Gartenstuhl", "Klein- und Grossobjekte"],
        },
      },
    },
    gallery: {
      overline: "Referenzen",
      title: "Unsere Projekte",
      subtitle: "Ein Auszug aus Hunderten erfolgreich umgesetzten Aufträgen.",
      filter_all: "Alle",
      filter_innen: "Innen",
      filter_aussen: "Fassaden",
      filter_holz: "Holzarbeiten",
      filter_spezial: "Spachteltechnik",
    },
    about: {
      overline: "Über uns",
      title: "Handwerk mit Leidenschaft seit 2018",
      lead: "Das Malergeschäft Sammy Felber wurde 2018 übernommen und steht heute für höchste handwerkliche Qualität im Raum Basel.",
      p1: "Als eidg. dipl. Maler bringt Sammy Felber langjährige Erfahrung in allen Bereichen der Maler-, Tapezier- und Fassadenarbeiten mit. Unser Team kombiniert traditionelles Handwerk mit modernen Techniken – ob klassische Renovation, anspruchsvolle Spachteltechniken wie Stucco Veneziano oder die behutsame Restauration historischer Bausubstanz.",
      p2: "Wir arbeiten für Privatkunden, Architekturbüros und KMU's. Mit unserer hauseigenen Spritzwerkstatt realisieren wir auch anspruchsvollste Lackierarbeiten – von der Jalousie bis zum Grossobjekt, hochglanz oder matt.",
      values_title: "Unsere Werte",
      v1_title: "Qualität",
      v1_text: "Wir liefern Resultate, die Jahrzehnte halten.",
      v2_title: "Zuverlässigkeit",
      v2_text: "Termine, Budget und Sauberkeit – auf uns ist Verlass.",
      v3_title: "Transparenz",
      v3_text: "Offene Kommunikation und faire Preise.",
      v4_title: "Leidenschaft",
      v4_text: "Wir lieben unser Handwerk – das sieht man an jedem Detail.",
    },
    contact: {
      overline: "Kontakt",
      title: "Lassen Sie uns über Ihr Projekt sprechen",
      subtitle: "Wir freuen uns auf Ihre Anfrage. Eine kostenlose Beratung ist nur einen Anruf entfernt.",
      form_name: "Name",
      form_email: "E-Mail",
      form_phone: "Telefon",
      form_service: "Dienstleistung",
      form_service_placeholder: "Bitte wählen…",
      form_message: "Ihre Nachricht",
      form_send: "Nachricht senden",
      form_sending: "Wird gesendet…",
      form_success: "Vielen Dank! Wir melden uns innerhalb von 24 Stunden bei Ihnen.",
      form_error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder rufen Sie uns direkt an.",
      info_title: "Kontaktinformationen",
      info_address: "Adresse",
      info_phone: "Telefon",
      info_email: "E-Mail",
      info_hours: "Öffnungszeiten",
      info_hours_value: "Mo–Fr · 07:30–17:30",
      whatsapp: "WhatsApp",
    },
    footer: {
      rights: "Alle Rechte vorbehalten.",
      services_title: "Dienstleistungen",
      contact_title: "Kontakt",
      links_title: "Navigation",
      imprint: "Impressum",
      privacy: "Datenschutz",
    },
    testimonials: [
      { quote: "Kompetent, schnell und sauber gearbeitet. Wir sind sehr zufrieden.", author: "Ja Vetesnik", role: "Google Rezension" },
      { quote: "Sehr zuverlässiger und kompetenter Maler.", author: "Angelo Nardone", role: "Google Rezension" },
      { quote: "Super Fassade – danke Ihnen Herr Felber!", author: "cam darf", role: "Google Rezension" },
    ],
  },
  en: {
    common: {
      phone: "+41 79 607 01 48", email: "info@sf-maler.ch",
      address: "Wollbacherstrasse 35, 4058 Basel",
      company: "Malergeschäft Sammy Felber",
      tagline: "Painting · Wallpapering · Facades",
      cta_offer: "Request a quote", cta_call: "Call now",
      cta_contact: "Get in touch", cta_consult: "Free consultation",
      cta_more: "Learn more", cta_send: "Send message", learn_more: "Learn more",
    },
    nav: { home: "Home", services: "Services", gallery: "Projects", team: "Team", about: "About", about_overview: "Company & Values", contact: "Contact", all_services: "View all services" },
    segment: { private: "Private Clients", commercial: "Commercial & Real Estate", private_short: "Private", commercial_short: "Commercial" },
    home: {
      hero_overline: "Sammy Felber Painting · Basel",
      hero_title: "Painters. Decorators. Facade Experts.",
      hero_subtitle: "An experienced and professional company specialising in interior painting, wallpapering and facade work. Whether renovation, conversion or new build – your reliable partner in Basel.",
      hero_trust1: "Federally certified painter", hero_trust2: "Serving Basel since 2018", hero_trust3: "In-house spray workshop",
      hero_title_private: "Painter in Basel for your flat, house or renovation.",
      hero_subtitle_private: "The reliable master painter for private clients in Basel. Fast, clean, fair fixed prices. Free on-site consultation within 48 hours.",
      hero_title_commercial: "Your partner for facades, real estate & large objects.",
      hero_subtitle_commercial: "Painting company for property managers, architects and SMEs in Basel. Framework contracts, general-contractor ready, punctuality guaranteed.",
      services_overline: "What we do", services_title: "Our services",
      services_subtitle: "From the first brushstroke to the finished facade – Swiss precision craftsmanship.",
      why_overline: "Why SF-Maler", why_title: "Quality, Service & Experience",
      why_subtitle: "Six reasons private clients, architects and SMEs trust us.",
      why_1_title: "Quality & Service", why_1_text: "Clean, durable results – guaranteed.",
      why_2_title: "Experience", why_2_text: "Federally certified painter with years of practice.",
      why_3_title: "Reliability", why_3_text: "On time, clean, straightforward.",
      why_4_title: "Stucco specialist", why_4_text: "Stucco Antico, Veneziano and more.",
      why_5_title: "Own spray workshop", why_5_text: "Gloss, matte – small to large objects.",
      why_6_title: "Heritage care", why_6_text: "Experience with historic structures.",
      ba_overline: "Before · After", ba_title: "See the difference",
      ba_subtitle: "Real projects. Real results. Move the slider.",
      gallery_overline: "Projects", gallery_title: "Selected work",
      gallery_subtitle: "A small selection of our recent work in Basel and surroundings.",
      gallery_cta: "View all projects",
      testimonials_overline: "Testimonials", testimonials_title: "What clients say",
      cta_section_title: "Ready to start your project?",
      cta_section_text: "Book a free, no-obligation consultation. We visit your property and provide a fair quote.",
    },
    services: {
      overline: "Services", title: "Our complete offering",
      subtitle: "From classic painting to specialty techniques – everything from one source.",
      detail_intro: "Scope of work",
      detail_cta_title: "Request a free quote",
      detail_cta_text: "Free consultation and a tailored offer.",
      items: {
        malerarbeiten: { title: "Painting", short: "Interior and exterior painting in the highest quality.", features: [] },
        tapezier: { title: "Wallpapering", short: "From removal of old wallpaper to exclusive stucco techniques.", features: [] },
        fassaden: { title: "Facades", short: "Complete facade renovation, insulation and protection.", features: [] },
        daemmung: { title: "Insulation", short: "Thermal upgrade of your building – inside and out.", features: [] },
        holzmalerei: { title: "Wood painting", short: "Sanding, filling, glazing or lacquering wooden surfaces.", features: [] },
        stuck: { title: "Stucco mouldings", short: "Decorative profiles for interior and facade.", features: [] },
        trockenbau: { title: "Drywall", short: "Plasterboard ceilings, partition walls and attic conversion.", features: [] },
        putz: { title: "Plastering", short: "Classic interior and exterior plaster – machine or manual.", features: [] },
        spritz: { title: "Spray finishing", short: "In-house spray workshop for demanding lacquer work.", features: [] },
      },
    },
    gallery: { overline: "Projects", title: "Our work", subtitle: "A selection of hundreds of successful jobs.", filter_all: "All", filter_innen: "Interior", filter_aussen: "Facades", filter_holz: "Wood", filter_spezial: "Stucco" },
    about: { overline: "About", title: "Craftsmanship with passion since 2018",
      lead: "Malergeschäft Sammy Felber was taken over in 2018 and now stands for the highest craftsmanship in the Basel region.",
      p1: "Sammy Felber, a federally certified painter, brings years of experience across all areas of painting, wallpapering and facade work. Our team combines traditional craftsmanship with modern techniques.",
      p2: "We serve private clients, architects and SMEs. With our in-house spray workshop we also handle demanding lacquer work – from shutters to large objects, gloss or matte.",
      values_title: "Our values",
      v1_title: "Quality", v1_text: "Results that last decades.",
      v2_title: "Reliability", v2_text: "Schedule, budget and cleanliness – count on us.",
      v3_title: "Transparency", v3_text: "Open communication and fair prices.",
      v4_title: "Passion", v4_text: "We love what we do – it shows in every detail." },
    contact: {
      overline: "Contact", title: "Let's talk about your project",
      subtitle: "We look forward to hearing from you. A free consultation is just one call away.",
      form_name: "Name", form_email: "Email", form_phone: "Phone", form_service: "Service",
      form_service_placeholder: "Please select…", form_message: "Your message",
      form_send: "Send message", form_sending: "Sending…",
      form_success: "Thank you! We will get back to you within 24 hours.",
      form_error: "Something went wrong. Please try again or call us directly.",
      info_title: "Contact information",
      info_address: "Address", info_phone: "Phone", info_email: "Email",
      info_hours: "Hours", info_hours_value: "Mon–Fri · 07:30–17:30", whatsapp: "WhatsApp",
    },
    footer: { rights: "All rights reserved.", services_title: "Services", contact_title: "Contact", links_title: "Navigation", imprint: "Imprint", privacy: "Privacy" },
    testimonials: [
      { quote: "Competent, fast and clean work. We are very satisfied.", author: "Ja Vetesnik", role: "Google review" },
      { quote: "Very reliable and skilled painter.", author: "Angelo Nardone", role: "Google review" },
      { quote: "Great facade – thank you Mr. Felber!", author: "cam darf", role: "Google review" },
    ],
  },
  fr: {
    common: {
      phone: "+41 79 607 01 48", email: "info@sf-maler.ch",
      address: "Wollbacherstrasse 35, 4058 Bâle",
      company: "Malergeschäft Sammy Felber",
      tagline: "Peinture · Tapisserie · Façades",
      cta_offer: "Demander un devis", cta_call: "Appeler", cta_contact: "Nous contacter",
      cta_consult: "Conseil gratuit", cta_more: "En savoir plus", cta_send: "Envoyer", learn_more: "En savoir plus",
    },
    nav: { home: "Accueil", services: "Services", gallery: "Réalisations", team: "Équipe", about: "À propos", about_overview: "Entreprise & Valeurs", contact: "Contact", all_services: "Voir tous les services" },
    segment: { private: "Particuliers", commercial: "Entreprises & Immobilier", private_short: "Particuliers", commercial_short: "Entreprises" },
    home: {
      hero_overline: "Sammy Felber Peinture · Bâle",
      hero_title: "Peintres. Tapissiers. Spécialistes des façades.",
      hero_subtitle: "Une entreprise expérimentée et professionnelle, spécialisée dans la peinture intérieure, la pose de papiers peints et les travaux de façade. Rénovation, transformation ou construction neuve – votre partenaire de confiance à Bâle.",
      hero_trust1: "Peintre diplômé fédéral", hero_trust2: "À Bâle depuis 2018", hero_trust3: "Atelier de peinture intégré",
      hero_title_private: "Peintre à Bâle pour votre appartement, maison ou rénovation.",
      hero_subtitle_private: "Le maître peintre fiable pour les particuliers à Bâle. Rapide, propre, prix fixes équitables. Conseil gratuit sous 48 heures.",
      hero_title_commercial: "Votre partenaire pour façades, immobilier et grands objets.",
      hero_subtitle_commercial: "Peintre pour régies, architectes et PME. Contrats-cadres, prêt entreprise générale, ponctualité garantie.",
      services_overline: "Ce que nous faisons", services_title: "Nos services",
      services_subtitle: "Du premier coup de pinceau à la façade terminée – précision artisanale suisse.",
      why_overline: "Pourquoi SF-Maler", why_title: "Qualité, service et expérience",
      why_subtitle: "Six raisons pour lesquelles particuliers, architectes et PME nous font confiance.",
      why_1_title: "Qualité & service", why_1_text: "Des résultats propres et durables – garantis.",
      why_2_title: "Expérience", why_2_text: "Peintre diplômé fédéral, des années de pratique.",
      why_3_title: "Fiabilité", why_3_text: "Ponctuel, propre, simple.",
      why_4_title: "Spécialiste stuc", why_4_text: "Stucco Antico, Veneziano et plus.",
      why_5_title: "Atelier de peinture", why_5_text: "Brillant, mat – petits et grands objets.",
      why_6_title: "Patrimoine", why_6_text: "Expérience sur bâtiments historiques.",
      ba_overline: "Avant · Après", ba_title: "Voyez la différence",
      ba_subtitle: "Vrais projets. Vrais résultats. Bougez le curseur.",
      gallery_overline: "Réalisations", gallery_title: "Travaux sélectionnés",
      gallery_subtitle: "Un aperçu de nos derniers travaux à Bâle et environs.",
      gallery_cta: "Voir toutes les réalisations",
      testimonials_overline: "Témoignages", testimonials_title: "Ce que disent nos clients",
      cta_section_title: "Prêt pour votre projet ?",
      cta_section_text: "Prenez rendez-vous pour un conseil gratuit et sans engagement.",
    },
    services: {
      overline: "Services", title: "Notre offre complète",
      subtitle: "De la peinture classique aux techniques spéciales – tout chez un seul prestataire.",
      detail_intro: "Prestations",
      detail_cta_title: "Demandez un devis gratuit",
      detail_cta_text: "Conseil gratuit et offre sur mesure.",
      items: {
        malerarbeiten: { title: "Peinture", short: "Peinture intérieure et extérieure de la plus haute qualité.", features: [] },
        tapezier: { title: "Tapisserie", short: "De la dépose des anciens papiers peints aux techniques de stuc exclusives.", features: [] },
        fassaden: { title: "Façades", short: "Rénovation complète, isolation et protection des façades.", features: [] },
        daemmung: { title: "Isolation", short: "Amélioration thermique de votre bâtiment.", features: [] },
        holzmalerei: { title: "Peinture sur bois", short: "Ponçage, mastic, lasure ou laquage des surfaces en bois.", features: [] },
        stuck: { title: "Moulures", short: "Profils décoratifs en polystyrène pour intérieur et façade.", features: [] },
        trockenbau: { title: "Cloisons sèches", short: "Plafonds en plaques de plâtre, cloisons et aménagement de combles.", features: [] },
        putz: { title: "Crépi", short: "Crépi intérieur et extérieur classique – à la machine ou à la main.", features: [] },
        spritz: { title: "Peinture au pistolet", short: "Atelier de peinture intégré pour travaux exigeants.", features: [] },
      },
    },
    gallery: { overline: "Réalisations", title: "Nos projets", subtitle: "Un aperçu de centaines de chantiers réussis.", filter_all: "Tous", filter_innen: "Intérieur", filter_aussen: "Façades", filter_holz: "Bois", filter_spezial: "Stuc" },
    about: { overline: "À propos", title: "L'artisanat avec passion depuis 2018",
      lead: "L'entreprise a été reprise en 2018 et représente aujourd'hui le plus haut niveau artisanal dans la région bâloise.",
      p1: "Sammy Felber, peintre diplômé fédéral, apporte des années d'expérience dans tous les domaines de la peinture, de la tapisserie et des façades.",
      p2: "Nous travaillons pour particuliers, architectes et PME. Notre atelier de peinture intégré permet aussi les travaux de laquage les plus exigeants.",
      values_title: "Nos valeurs",
      v1_title: "Qualité", v1_text: "Des résultats qui durent des décennies.",
      v2_title: "Fiabilité", v2_text: "Délais, budget et propreté – comptez sur nous.",
      v3_title: "Transparence", v3_text: "Communication ouverte et prix équitables.",
      v4_title: "Passion", v4_text: "Nous aimons notre métier – cela se voit." },
    contact: {
      overline: "Contact", title: "Parlons de votre projet",
      subtitle: "Un conseil gratuit est à un appel de distance.",
      form_name: "Nom", form_email: "E-mail", form_phone: "Téléphone", form_service: "Service",
      form_service_placeholder: "Veuillez choisir…", form_message: "Votre message",
      form_send: "Envoyer", form_sending: "Envoi…",
      form_success: "Merci ! Nous vous répondrons sous 24 heures.",
      form_error: "Une erreur est survenue. Veuillez réessayer ou nous appeler.",
      info_title: "Coordonnées",
      info_address: "Adresse", info_phone: "Téléphone", info_email: "E-mail",
      info_hours: "Horaires", info_hours_value: "Lun–Ven · 07:30–17:30", whatsapp: "WhatsApp",
    },
    footer: { rights: "Tous droits réservés.", services_title: "Services", contact_title: "Contact", links_title: "Navigation", imprint: "Mentions légales", privacy: "Confidentialité" },
    testimonials: [
      { quote: "Travail compétent, rapide et propre. Nous sommes très satisfaits.", author: "Ja Vetesnik", role: "Avis Google" },
      { quote: "Peintre très fiable et compétent.", author: "Angelo Nardone", role: "Avis Google" },
      { quote: "Superbe façade – merci Monsieur Felber !", author: "cam darf", role: "Avis Google" },
    ],
  },
  it: {
    common: {
      phone: "+41 79 607 01 48", email: "info@sf-maler.ch",
      address: "Wollbacherstrasse 35, 4058 Basilea",
      company: "Malergeschäft Sammy Felber",
      tagline: "Pittura · Tappezzeria · Facciate",
      cta_offer: "Richiedi un preventivo", cta_call: "Chiama ora", cta_contact: "Contattaci",
      cta_consult: "Consulenza gratuita", cta_more: "Scopri di più", cta_send: "Invia", learn_more: "Scopri di più",
    },
    nav: { home: "Home", services: "Servizi", gallery: "Lavori", team: "Team", about: "Chi siamo", about_overview: "Azienda & Valori", contact: "Contatti", all_services: "Mostra tutti i servizi" },
    segment: { private: "Privati", commercial: "Aziende & Immobili", private_short: "Privati", commercial_short: "Aziende" },
    home: {
      hero_overline: "Sammy Felber Pittura · Basilea",
      hero_title: "Pittori. Tappezzieri. Specialisti di facciate.",
      hero_subtitle: "Un'azienda esperta e professionale, specializzata nella pittura di interni, tappezzeria e lavori di facciata. Ristrutturazione, ampliamento o nuova costruzione – il vostro partner affidabile a Basilea.",
      hero_trust1: "Pittore diplomato federale", hero_trust2: "A Basilea dal 2018", hero_trust3: "Officina di verniciatura interna",
      hero_title_private: "Pittore a Basilea per appartamento, casa o ristrutturazione.",
      hero_subtitle_private: "Il maestro pittore affidabile per privati a Basilea. Veloce, pulito, prezzi fissi equi. Consulenza gratuita entro 48 ore.",
      hero_title_commercial: "Il vostro partner per facciate, immobili e grandi oggetti.",
      hero_subtitle_commercial: "Impresa di pittura per amministrazioni, architetti e PMI. Contratti quadro, pronti per general contractor, puntualità garantita.",
      services_overline: "Cosa facciamo", services_title: "I nostri servizi",
      services_subtitle: "Dalla prima pennellata alla facciata finita – precisione svizzera.",
      why_overline: "Perché SF-Maler", why_title: "Qualità, servizio ed esperienza",
      why_subtitle: "Sei ragioni per cui privati, architetti e PMI si affidano a noi.",
      why_1_title: "Qualità & servizio", why_1_text: "Risultati puliti e duraturi – garantiti.",
      why_2_title: "Esperienza", why_2_text: "Pittore diplomato federale, anni di pratica.",
      why_3_title: "Affidabilità", why_3_text: "Puntualità, pulizia, semplicità.",
      why_4_title: "Specialista stucco", why_4_text: "Stucco Antico, Veneziano e altro.",
      why_5_title: "Officina interna", why_5_text: "Lucido, opaco – piccoli e grandi oggetti.",
      why_6_title: "Beni culturali", why_6_text: "Esperienza su edifici storici.",
      ba_overline: "Prima · Dopo", ba_title: "Vedete la differenza",
      ba_subtitle: "Progetti reali. Risultati reali. Muovete il cursore.",
      gallery_overline: "Lavori", gallery_title: "Progetti selezionati",
      gallery_subtitle: "Una selezione dei nostri ultimi lavori a Basilea.",
      gallery_cta: "Vedi tutti i lavori",
      testimonials_overline: "Testimonianze", testimonials_title: "Cosa dicono i clienti",
      cta_section_title: "Pronti per il vostro progetto?",
      cta_section_text: "Fissate una consulenza gratuita e senza impegno.",
    },
    services: {
      overline: "Servizi", title: "La nostra offerta completa",
      subtitle: "Dalla pittura classica alle tecniche speciali – tutto da un unico fornitore.",
      detail_intro: "Prestazioni",
      detail_cta_title: "Richiedi un preventivo gratuito",
      detail_cta_text: "Consulenza gratuita e offerta su misura.",
      items: {
        malerarbeiten: { title: "Pittura", short: "Pittura interna ed esterna della massima qualità.", features: [] },
        tapezier: { title: "Tappezzeria", short: "Dalla rimozione delle vecchie tappezzerie alle tecniche di stucco esclusive.", features: [] },
        fassaden: { title: "Facciate", short: "Risanamento completo, isolamento e protezione delle facciate.", features: [] },
        daemmung: { title: "Isolamento", short: "Miglioramento termico dell'edificio.", features: [] },
        holzmalerei: { title: "Pittura del legno", short: "Carteggio, stuccatura, vernici o lacche per superfici in legno.", features: [] },
        stuck: { title: "Stucchi", short: "Profili decorativi in polistirolo per interni e facciate.", features: [] },
        trockenbau: { title: "Cartongesso", short: "Soffitti in cartongesso, pareti divisorie e mansarde.", features: [] },
        putz: { title: "Intonaco", short: "Intonaco interno ed esterno classico.", features: [] },
        spritz: { title: "Verniciatura a spruzzo", short: "Officina interna per lavori esigenti.", features: [] },
      },
    },
    gallery: { overline: "Lavori", title: "I nostri progetti", subtitle: "Una selezione di centinaia di lavori riusciti.", filter_all: "Tutti", filter_innen: "Interni", filter_aussen: "Facciate", filter_holz: "Legno", filter_spezial: "Stucco" },
    about: { overline: "Chi siamo", title: "Artigianato con passione dal 2018",
      lead: "L'azienda è stata rilevata nel 2018 e oggi rappresenta la massima qualità artigianale nella regione di Basilea.",
      p1: "Sammy Felber, pittore diplomato federale, porta anni di esperienza in tutti i settori della pittura, tappezzeria e facciate.",
      p2: "Lavoriamo per privati, architetti e PMI. La nostra officina di verniciatura interna ci permette di eseguire anche i lavori più esigenti.",
      values_title: "I nostri valori",
      v1_title: "Qualità", v1_text: "Risultati che durano decenni.",
      v2_title: "Affidabilità", v2_text: "Tempi, budget e pulizia – contate su di noi.",
      v3_title: "Trasparenza", v3_text: "Comunicazione aperta e prezzi equi.",
      v4_title: "Passione", v4_text: "Amiamo il nostro mestiere – si vede in ogni dettaglio." },
    contact: {
      overline: "Contatti", title: "Parliamo del vostro progetto",
      subtitle: "Una consulenza gratuita è a una telefonata di distanza.",
      form_name: "Nome", form_email: "E-mail", form_phone: "Telefono", form_service: "Servizio",
      form_service_placeholder: "Selezionare…", form_message: "Il vostro messaggio",
      form_send: "Invia", form_sending: "Invio…",
      form_success: "Grazie! Vi risponderemo entro 24 ore.",
      form_error: "Qualcosa è andato storto. Riprovate o chiamateci.",
      info_title: "Contatti",
      info_address: "Indirizzo", info_phone: "Telefono", info_email: "E-mail",
      info_hours: "Orari", info_hours_value: "Lun–Ven · 07:30–17:30", whatsapp: "WhatsApp",
    },
    footer: { rights: "Tutti i diritti riservati.", services_title: "Servizi", contact_title: "Contatti", links_title: "Navigazione", imprint: "Note legali", privacy: "Privacy" },
    testimonials: [
      { quote: "Lavoro competente, veloce e pulito. Siamo molto soddisfatti.", author: "Ja Vetesnik", role: "Recensione Google" },
      { quote: "Imbianchino molto affidabile e competente.", author: "Angelo Nardone", role: "Recensione Google" },
      { quote: "Facciata fantastica – grazie signor Felber!", author: "cam darf", role: "Recensione Google" },
    ],
  },
};

export const SUPPORTED_LANGUAGES = [
  { code: "de", label: "DE" },
  { code: "en", label: "EN" },
  { code: "fr", label: "FR" },
  { code: "it", label: "IT" },
];
